<template>
  <div class="esp-big-slider">
    <agile :dots="false" :navButtons="false" ref="carousel" v-if="locationpics.length > 0">
      <div class="slide" v-for="(foto, index) in locationpics" :key="index">
        <img
          :src="`${siteBase}/${foto.foto}`"
          :alt="`${foto.alt || 'giardino photo'}`"
          draggable="false"
        />
      </div>
    </agile>
    <div class="navigation mt-5">
      <button @click="$refs.carousel.goToPrev()" class="me-5">
        <img src="../assets/img/prev-btn.svg" alt="prev" draggable="false" />
      </button>
      <button @click="$refs.carousel.goToNext()" class="ms-5">
        <img src="../assets/img/next-btn.svg" alt="next" draggable="false" />
      </button>
    </div>
  </div>
</template>

<script>
import { VueAgile } from "vue-agile";
import { SITE_BASE, siteApiUrl } from "@/siteBase.js";

export default {
  name: "EsperienzeBigSlider",
  components: {
    agile: VueAgile,
  },

  computed: {
    siteBase() {
      return SITE_BASE;
    },
  },

  data() {
    return {
      locationpics: [],
    };
  },

  async mounted() {
    let data = await fetch(siteApiUrl("api/location-slideshow.json"));
    let locationpics = await data.json();

    this.locationpics = locationpics;
  },
};
</script>

<style>
</style>